import React, { useEffect, useState } from "react";
import "./calltoaction.scss";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import ctaBg from "../../../assets/images/insurance-assets/cta-bg.svg";


const CallToAction = ({ data }) => {
  const [sectionTitle, setSectionTitle] = useState({
    first: "",
    second: "",
    third: "",
  });
  useEffect(() => {
    let first;
    let second;
    let third = "";
    if (data.section2_title) {
      const [weHave, got, you, covered] = data.section2_title.split(" ");
      first = weHave;
      second = `${got} ${you}`;
      third = covered;
      setSectionTitle({ first, second, third });
    }
  }, [data]);
  return (
    <section className="section calltoaction position-relative" style={{backgroundImage:`url(${ctaBg})`}}>
          <Col lg={7} xs={12} className="pe-lg-5 ps-lg-0 py-lg-5 overflow-hidden cta-left-bg d-lg-block d-none">
            {data?.section2_client_image !== undefined && (
              <img src={data?.section2_client_image} className="" alt={data?.section2_client_title} />
            )}
          <div className="position-absolute top-50 translate-middle-y text-white cta-heading-outer">
            <h1 className="cta-heading">{parse(sectionTitle.first)}</h1>
            <h1 className="cta-heading">{parse(sectionTitle.second)}</h1>
            <h1 className="cta-heading">{parse(sectionTitle.third)}</h1>
          </div>
        </Col>
      <Container>
        <Row>
        <Col lg={7} xs={12} className="position-relative overflow-hidden d-lg-none d-block">
            {data?.section2_client_image !== undefined && (
              <img src={data?.section2_client_image} className="img-fluid" alt={data?.section2_client_title} />
            )}
          <div className="position-absolute top-50 start-50 translate-middle text-white cta-heading-outer">
            <h1 className="cta-heading">{parse(sectionTitle.first)}</h1>
            <h1 className="cta-heading">{parse(sectionTitle.second)}</h1>
            <h1 className="cta-heading">{parse(sectionTitle.third)}</h1>
          </div>
        </Col>
        <Col xxl={5} lg={6} xs={12} className="cta-content-outer offset-lg-6 px-ld-2 px-sm-5 px-4 mt-lg-0 mt-n4">
          <div className="cta-content p-5 bg-white position-relative">
            <p className="text-xxl">{data?.section2_client_title}</p>

            <div className="terms-content">{parse(data?.section2_client_description || "")}</div>
            <div className="mt-5">
              <Link to="/select-insurance" className="btn btn-primary">
                {parse(data?.section2_button_title || "")}
              </Link>
            </div>
          </div>
        </Col>
        </Row>
      </Container>
    </section>
  );
};

export default CallToAction;
